import React from "react";

import {
    Empty,
    List,
    Skeleton
} from "antd";

import ConversationNotificationCard
    from "./cards/ConversationNotificationCard";

import OrderNotificationCard
    from "./cards/OrderNotificationCard";

import PaymentNotificationCard
    from "./cards/PaymentNotificationCard";

import DeliveryNotificationCard
    from "./cards/DeliveryNotificationCard";

import NotificationCard
    from "./NotificationCard";
import ConversationNotificationCardOld from "./cards/ConversationNotificationCardOld";
import TransactionDrawerOld from "./drawer/TransactionDrawerOld";

    const NotificationList = ({
                                  loading,
                                  notifications,
                                  onOpenConversation,
                                  onOpenOrder,
                                  onOpenTransaction,
                                  onMarkAsRead
                              }) => {

    if (loading) {
        return (
            <Skeleton
                active
                paragraph={{ rows: 6 }}
            />
        );
    }

    if (
        !Array.isArray(notifications) ||
        notifications.length === 0
    ) {
        return (
            <Empty
                description="Aucune notification"
            />
        );
    }

    return (
        <List
            dataSource={notifications}
            split={false}
            renderItem={(notification) => {

                const key = notification.id;

                switch (notification.notificationType) {

                    case "CONVERSATION":

                        return (
                            <List.Item key={key}>
                                <ConversationNotificationCard
                                    notification={notification}
                                    onOpenConversation={
                                        onOpenConversation
                                    }
                                    onMarkAsRead={
                                        onMarkAsRead
                                    }
                                />
                            </List.Item>
                        );

                    case "ORDER":

                        return (
                            <List.Item key={key}>
                                <OrderNotificationCard
                                    notification={notification}
                                    onOpenOrder={onOpenOrder}
                                    onMarkAsRead={
                                        onMarkAsRead
                                    }
                                />
                            </List.Item>
                        );

                    case "PAYMENT":

                        return (
                            <List.Item key={key}>
                                <PaymentNotificationCard
                                    notification={notification}
                                    onMarkAsRead={
                                        onMarkAsRead
                                    }
                                />
                            </List.Item>
                        );

                    case "DELIVERY":

                        return (
                            <List.Item key={key}>
                                <DeliveryNotificationCard
                                    notification={notification}
                                    onMarkAsRead={
                                        onMarkAsRead
                                    }
                                />
                            </List.Item>
                        );

                    case "PRODUCT":

                        return (
                            <List.Item key={key}>
                                <ConversationNotificationCardOld
                                    notification={notification}
                                    onMarkAsRead={
                                        onMarkAsRead
                                    }
                                />
                            </List.Item>
                        );

                    default:

                        return (
                            <List.Item key={key}>
                                <NotificationCard
                                    notification={notification}
                                    onMarkAsRead={
                                        onMarkAsRead
                                    }
                                />
                            </List.Item>
                        );
                }
            }}
        />
    );
};

export default NotificationList;